// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3g6fW","tab":"ProcedureTabs_tab__3mQiE"};